import { ColumnsType } from 'antd/es/table';

import { OrderHistorySchema } from '@app/models/orders';

import { formatDateAndTimeShort } from '@app/services/date';

export const BASE_COLUMNS: ColumnsType<OrderHistorySchema> = [
  {
    title: 'historyTable.created_at',
    dataIndex: 'created_at',
    key: 'created_at',
    ellipsis: true,
    render: (_, data) => formatDateAndTimeShort(data.created_at),
  },
  {
    title: 'historyTable.order_status',
    dataIndex: 'order_status_uid',
    key: 'order_status_uid',
  },
  {
    title: 'historyTable.name',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
    // user может быть null для системных переходов (автопродвижение по складу и т.п.)
    render: (_, data) => data.user?.name ?? 'WMS',
  },
  {
    title: 'historyTable.comment',
    dataIndex: 'comment',
    key: 'comment',
    ellipsis: true,
    render: (_, data) => {
      if (
        data.info.kind === 'cancelled' ||
        data.info.kind === 'system_cancelled' ||
        data.info.kind === 'approved' ||
        data.info.kind === 'marked_as_needs_work'
      ) {
        return data.info.comment;
      }
      return '';
    },
  },
  {
    title: 'historyTable.kind',
    dataIndex: 'kind',
    key: 'kind',
    ellipsis: true,
    render: (_, data) => data.info.kind,
  },
];
